import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { DiscountType } from "../types/proposal";

type Props = {
  type: DiscountType;
  value: number;
  onTypeChange: (type: DiscountType) => void;
  onValueChange: (value: number) => void;
};

const DiscountCard: React.FC<Props> = ({
  type,
  value,
  onTypeChange,
  onValueChange,
}) => (
  <Card>
    <CardHeader title="Desconto" subheader="Aplique somente quando necessário" />
    <CardContent>
      <Stack direction={{ xs: "column", md: "row" }} gap={2} alignItems="flex-start">
        <FormControl sx={{ flex: 1 }}>
          <RadioGroup
            row
            value={type}
            onChange={event => onTypeChange(event.target.value as DiscountType)}
            color="success"
          >
            <FormControlLabel value="none" control={<Radio color="success" />} label="Sem desconto" />
            <FormControlLabel value="fixed" control={<Radio color="success" />} label="Valor em reais" />
            <FormControlLabel value="percentage" control={<Radio color="success" />} label="Percentual" />
          </RadioGroup>
        </FormControl>

        {type !== "none" && (
          <TextField
            type="number"
            label={type === "fixed" ? "Valor do desconto" : "Percentual"}
            value={value || ""}
            onChange={event => onValueChange(Number(event.target.value))}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  {type === "fixed" ? "R$" : "%"}
                </InputAdornment>
              ),
            }}
            inputProps={{ min: 0, max: type === "percentage" ? 100 : undefined, step: 0.01 }}
            sx={{ width: { xs: "100%", md: 220 } }}
          />
        )}
      </Stack>
    </CardContent>
  </Card>
);

export default DiscountCard;
